import { render, staticRenderFns } from "./WorkforceInvitationModal.vue?vue&type=template&id=771ab8f0&scoped=true"
import script from "./WorkforceInvitationModal.vue?vue&type=script&lang=js"
export * from "./WorkforceInvitationModal.vue?vue&type=script&lang=js"
import style0 from "./WorkforceInvitationModal.vue?vue&type=style&index=0&id=771ab8f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771ab8f0",
  null
  
)

export default component.exports